<template>
  <div class="course">
    <div class="course__left">
      <img :src="banner" />
      <p class="course-sales">
        <span class="num">{{ sales }}</span>
        人已购买
      </p>
    </div>

    <div class="course__r">
      <p class="course-name ellipsis">{{ indexName + " " + courseName }}</p>
      <ul class="course-tags">
        <li>权威性</li>
        <li>更高含金量</li>
        <li>认可度</li>
      </ul>
      <div class="course__r__ft">
        <p class="course-comment">好评度 100%</p>
        <p class="course-price">
          ￥<span class="price">{{ price }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    nsme: 'CourseItem',
    props: ['banner', 'sales', 'indexName', 'courseName', 'price'],
  };
</script>

<style lang="scss" scoped>
.course {
  display: flex;
  cursor: pointer;
}

.course + .course {
  margin-top: 20px;
}

.course__left {
  flex: none;
  position: relative;
  width: 120px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
}

.course__left img {
  width: 100%;
}

.course__left .course-sales {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  font-size: 12px;
  color: #999;
  line-height: 18px;
  text-align: center;
  background-color: #ddd;
}

.course__r {
  flex: 1;
  position: relative;
  margin-left: 15px;
  overflow: hidden;
}

.course-name {
  font-size: 12px;
  color: #333;
}

.course-tags {
  display: flex;
  margin-top: 8px;
}

.course-tags > li {
  padding: 2px 4px;
  font-size: 10px;
  color: #30c27b;
  border: 1px solid;
  border-radius: 4px;
}

.course-tags > li + li {
  margin-left: 5px;
}

.course__r__ft {
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.course-comment {
  font-size: 12px;
  color: #999;
}

.course-price {
  font-size: 14px;
  color: #fa666a;
}
</style>
